<template>
  <div v-if="fournisseur">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailFournisseur.title', { nom: fournisseur.nomCommercial }) }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">

          <dropdownButton
            type="is-addOrEdit"
            v-if="!fournisseur.lienUtilisateurId"
            class="mgr-2"
            :permission="getPerm.maj"
            :actions="actionSecondary"
            @click="() => {
              $router.push({ name: getNameRouteEdition,
                params: { id: fournisseur.id, sousTypeFrom: $route.params.sousTypeFrom } });
            }">
              {{ $t('detailFournisseur.actions.edit') }}
          </dropdownButton>

            <b-tooltip class="mr-2"
              position= "is-left"
              :label="$i18n.t('detailFournisseur.tooltipFournisseurUser')"
              v-else>
              <button class="button  button-access-no-permission" disabled>
                {{ $t('detailFournisseur.actions.edit') }}
              </button>
            </b-tooltip>
            <button class="button is-bottom-left has-text-left"
                    @click="checkPermissions(getPerm.lecture)
                      ? popUpEdition = true
                      : showPopUp()">
              <b-icon icon="file-download" type="is-default"></b-icon>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="getPerm.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-marginless is-paddingless section section-details">
      <div class="column is-10">
        <div class="columns is-multiline mgt-20px">
          <div class="column is-12">
            <div class="card" id="generalInformations">
              <header class="header-card">
                <p>
                  {{ $t('detailFournisseur.informationsGenerales.title')}}
                </p>
              </header>
              <info-generales :fournisseur="fournisseur" :isFactor="isFactor"></info-generales>
            </div>
          </div>
          <div class="column is-12">
            <div class="card" id="contacts">
              <header class="header-card">
                <p>
                  {{ $t('detailFournisseur.contacts.title')}}
                </p>
              </header>
              <contacts :tier="fournisseur"></contacts>
            </div>
          </div>
          <div class="column is-12" v-if="!isDemarcheur">
            <div class="card" id="bankDetails">
              <header class="header-card">
                <p>
                  {{ $t('detailFournisseur.infoBancaire.title')}}
                </p>
              </header>
              <info-bancaires :fournisseur="fournisseur"></info-bancaires>
            </div>
          </div>
          <div class="column" :class="hideInfoCmd ? 'is-12' : 'is-6'">
            <div class="card" id="compta">
              <header class="header-card">
                <p>
                  {{ $t('detailFournisseur.infoCompta.title')}}
                </p>
              </header>
              <info-comptables
                :fournisseur="fournisseur"
                :isFactor="isFactor"
                :isDemarcheur="isDemarcheur">
              </info-comptables>
            </div>
          </div>
          <div class="column is-6" v-if="!hideInfoCmd">
            <info-commande :tiers="fournisseur"></info-commande>
          </div>
          <div class="column is-12">
            <div class="card" id="comments">
              <header class="header-card">
                <p>
                  {{ $t('detailFournisseur.commentaires.title')}}
                </p>
              </header>
              <div class="card-content has-text-default is-size-7">
                {{ fournisseur.commentairesInternes}}
              </div>
            </div>
          </div>
          <div v-if="isFactor" class="column is-12">
            <div class="card" id="comments">
              <header class="header-card">
                <p>
                  {{ $t('detailFournisseur.commentaires.titleFactor')}}
                </p>
              </header>
              <div class="card-content has-text-default is-size-7">
                <span v-html="fournisseur.commentaireFactor"></span>
              </div>
            </div>
          </div>
          <div class="column is-12">
            <div class="card" id="attachments">
              <header class="header-card">
                <p>
                  {{ $t('detailFournisseur.piecesJointes.title')}}
                </p>
              </header>
              <div class="card-content">
                <app-pieces-jointes readOnly
                                    deletable
                                    autoSave
                                    :checkPermissions=checkPermissions(getPerm.maj)
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="is-fixed mgt-20px">
          <dots-menu :steps="steps">
          </dots-menu>
          <information-create-update-user :data="fournisseur" class="mgr-20px">
          </information-create-update-user>
        </div>
      </div>
    </div>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention v-if="fournisseur"
        :messHeader="!fournisseur.archive ? archiveMessageTitle
        : desArchiveMessageTitle"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        @no="openPopUpPrevention = false"
        @yes="archiver"/>
    </b-modal>
    <b-modal
      v-if="fournisseur"
      v-model="openPopUpFusionTiers"
      :width="800"
      class="modal"
      has-modal-card>
      <popup-fusion-tiers
        :tiers="fournisseur"
        :type="constantes.TIERS_TYPE_FOURNISSEUR"
        :sousTypes="fournisseur.sousTypes"
        :tiersTypeForTrad="getTiersTypeForTradFusion">
      </popup-fusion-tiers>
    </b-modal>
    <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition="listeChoiceEdition"
        :filtreDates="true"
        @editionChoose="edition">
      </pop-up-edition>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import AppBreadcrumb from '@/components/general/breadcrumb';
import { get, archiverEnMasse } from '@/api/tiers';
import { getAllByTiers } from '@/api/contacts';
import dropdownButton from '@/components/general/button/dropdownButton';
import messageErreur from '@/services/general/messageErreur';
import DotsMenu from '@/components/general/dotsMenu';
import infoGenerales from '@/components/commun/fournisseur/detailFournisseur/infoGenerales';
import contacts from '@/components/tiers/contacts/contacts';
import infoBancaires from '@/components/commun/fournisseur/detailFournisseur/infoBancaires';
import infoComptables from '@/components/commun/fournisseur/detailFournisseur/infoComptables';
import PiecesJointes from '@/components/general/piecesJointes';
import { CONFRERE, FOURNISSEUR_MATERIEL } from '@/configuration/gabed/permissionsGabedConf';
import { AFFICHEUR } from '@/configuration/logistique/permissionsLogistiqueConf';
import { LIEU_DE_LIVRAISON } from '@/configuration/achat/permissionsConf';
import {
  TIERS_TYPE_FOURNISSEUR,
  TIERS_SOUS_TYPE_CONFRERE,
  TIERS_SOUS_TYPE_AFFICHEUR,
  TIERS_SOUS_TYPE_TECHNICIEN,
  TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL,
  TIERS_SOUS_TYPE_FACTOR,
  TIERS_SOUS_TYPE_DEMARCHEUR,
  TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON, LISTE_CHOICE_EDITION_TIERS, TYPE_DONNEE_EXTRAIT_COMPTE_TIERS,
} from '@/configuration/tiers/tiersConf';
import { DEMARCHEUR } from '@/configuration/baux/permissionsBauxConf';
import infoCommande from '@/components/commun/tiers/detailTiers/infoCommande';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import messageSucces from '@/services/general/messageSucces';
import popUpPrevention from '@/components/general/popUpPrevention';
import { FACTOR } from '@/configuration/permissionsBodacConf';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import popupFusionTiers from '@/components/clients/clients/popupFusionTiers';
import popUpEdition from '@/components/factures/p_edition';
import edition from '@/api/edition';
import validationGeneral from '@/services/validation/validation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      fournisseur: null,
      steps: [
        {
          name: this.$i18n.t('detailFournisseur.steps.infoGenerales'),
          ref: '#generalInformations',
          active: true,
        },
        {
          name: this.$i18n.t('detailFournisseur.steps.contacts'),
          ref: '#contacts',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseur.steps.infoBancaire'),
          ref: '#bankDetails',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseur.steps.infoCompta'),
          ref: '#compta',
          active: false,
        },
        {
          name: this.$i18n.t('detailTiers.steps.commande'),
          ref: '#infoCommande',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseur.steps.commentaires'),
          ref: '#comments',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseur.steps.piecesJointes'),
          ref: '#attachments',
          active: false,
        },
      ],
      openPopUpPrevention: false,
      constantes: {
        TIERS_TYPE_FOURNISSEUR,
        TIERS_SOUS_TYPE_AFFICHEUR,
        TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
      },
      openPopUpFusionTiers: false,
      listeChoiceEdition: LISTE_CHOICE_EDITION_TIERS
        .filter(l => l.typeDonnee === TYPE_DONNEE_EXTRAIT_COMPTE_TIERS),
      popUpEdition: false,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  components: {
    AppBreadcrumb,
    DotsMenu,
    infoGenerales,
    contacts,
    dropdownButton,
    infoBancaires,
    infoComptables,
    appPiecesJointes: PiecesJointes,
    infoCommande,
    InformationCreateUpdateUser,
    popUpPrevention,
    pieceJointeButton,
    popupFusionTiers,
    popUpEdition,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('detailFournisseur.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailFournisseur.breadcrumb.liste', { sousTypePluriel: this.getSousTypePluriel }), route: { name: this.getNameRouteListe }, isActive: false },
        { title: this.$i18n.t('detailFournisseur.breadcrumb.detail'), route: { name: '' }, isActive: true },
      ];
    },
    getSousTypePluriel() {
      switch (this.$route.params.sousTypeFrom) {
        case TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON:
          return this.$i18n.t('fournisseur.sousTypesPluriel.lieuDeLivraison');
        case TIERS_SOUS_TYPE_AFFICHEUR:
          return this.$i18n.t('fournisseur.sousTypesPluriel.afficheur');
        case TIERS_SOUS_TYPE_TECHNICIEN:
          return this.$i18n.t('fournisseur.sousTypesPluriel.technicien');
        case TIERS_SOUS_TYPE_DEMARCHEUR:
          return this.$i18n.t('fournisseur.sousTypesPluriel.demarcheur');
        case TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL:
          return this.$i18n.t('fournisseur.sousTypesPluriel.fournisseurMateriel');
        case TIERS_SOUS_TYPE_FACTOR:
          return this.$i18n.t('fournisseur.sousTypesPluriel.factor');
        default:
          if (this.isLieuDeLivraison) { return this.$i18n.t('fournisseur.sousTypesPluriel.lieuDeLivraison'); }
          return this.$i18n.t('fournisseur.sousTypesPluriel.confrere');
      }
    },
    getTiersTypeForTradFusion() {
      if ([
        TIERS_SOUS_TYPE_CONFRERE,
        TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL,
        TIERS_SOUS_TYPE_AFFICHEUR,
        TIERS_SOUS_TYPE_TECHNICIEN,
        TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON,
      ].includes(this.$route.params.sousTypeFrom)) {
        return this.$route.params.sousTypeFrom;
      }
      return 'fournisseur';
    },
    getNameRouteListe() {
      switch (this.$route.params.sousTypeFrom) {
        case TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON:
          return 'l.achat.lieu_de_livraison';
        case TIERS_SOUS_TYPE_AFFICHEUR:
          return 'l.logistique.afficheur';
        case TIERS_SOUS_TYPE_TECHNICIEN:
          return 'l.logistique.technicien';
        case TIERS_SOUS_TYPE_DEMARCHEUR:
          return 'l.baux.demarcheur';
        case TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL:
          return 'l.gabed.fournisseur_materiel';
        case TIERS_SOUS_TYPE_FACTOR:
          return 'l.bodac.factor';
        case TIERS_SOUS_TYPE_CONFRERE:
          return 'l.gabed.confrere';
        default:
          if (this.isLieuDeLivraison) { return 'l.achat.lieu_de_livraison'; }
          return 'l.achat.fournisseurs';
      }
    },
    getNameRouteEdition() {
      switch (this.$route.params.sousTypeFrom) {
        case TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON:
          return 'm.achat.lieu_de_livraison';
        case TIERS_SOUS_TYPE_AFFICHEUR:
          return 'm.logistique.afficheur-edition';
        case TIERS_SOUS_TYPE_TECHNICIEN:
          return 'm.logistique.technicien-edition';
        case TIERS_SOUS_TYPE_DEMARCHEUR:
          return 'm.baux.demarcheur-edition';
        case TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL:
          return 'm.gabed.fournisseur_materiel-edition';
        case TIERS_SOUS_TYPE_FACTOR:
          return 'm.bodac.factor-edition';
        default:
          return 'm.gabed.confrere-edition';
      }
    },
    getPerm() {
      switch (this.$route.params.sousTypeFrom) {
        case TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON:
          return LIEU_DE_LIVRAISON;
        case TIERS_SOUS_TYPE_AFFICHEUR:
          return AFFICHEUR;
        case TIERS_SOUS_TYPE_FOURNISSEUR_MATERIEL:
          return FOURNISSEUR_MATERIEL;
        case TIERS_SOUS_TYPE_DEMARCHEUR:
          return DEMARCHEUR;
        case TIERS_SOUS_TYPE_FACTOR:
          return FACTOR;
        default:
          return CONFRERE;
      }
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t(`detailClient.popupFusionTiers.${this.getTiersTypeForTradFusion}.title`),
          action: () => { this.openPopUpFusionTiers = true; },
        },
      ];

      if (this.isShowDeleteOrArchive) {
        actions.push(
          {
            label: this.$t('general.button.' + (!this.fournisseur.archive ? 'archiver' : 'desarchiver')),
            action: () => { this.openPopUpPrevention = true; },
            permissionAction: this.getPerm.supprimer,
          },
        );
      }

      if (this.isLieuDeLivraison) {
        actions.push(
          {
            label: this.$t('general.button.' + (!this.fournisseur.archive ? 'archiver' : 'desarchiver')),
            action: () => { this.openPopUpPrevention = true; },
            permissionAction: this.getPerm.supprimer,
          },
        );
      }

      return actions;
    },
    isShowDeleteOrArchive() {
      return this.$route.params.sousTypeFrom === TIERS_SOUS_TYPE_AFFICHEUR
          || this.isFactor;
    },
    isFactor() {
      return this.$route.params.sousTypeFrom === TIERS_SOUS_TYPE_FACTOR;
    },
    isDemarcheur() {
      return this.$route.params.sousTypeFrom === TIERS_SOUS_TYPE_DEMARCHEUR;
    },
    isLieuDeLivraison() {
      return this.fournisseur.sousTypes.includes('LieuDeLivraison');
    },
    hideInfoCmd() {
      return this.isLieuDeLivraison || this.isDemarcheur;
    },
    archiveMessageTitle() {
      if (this.$route.params.sousTypeFrom === TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON) {
        return this.isFactor ? this.$t('detailFournisseur.archivage.factorTitleDesarchiver')
          : this.$t('detailFournisseur.archivage.lieuDeLivrasonTitle');
      }
      return this.isFactor ? this.$t('detailFournisseur.archivage.factorTitle')
        : this.$t('detailFournisseur.archivage.title');
    },
    desArchiveMessageTitle() {
      if (this.$route.params.sousTypeFrom === TIERS_SOUS_TYPE_LIEU_DE_LIVRAISON) {
        return this.isFactor ? this.$t('detailFournisseur.archivage.factorTitleDesarchiver')
          : this.$t('detailFournisseur.archivage.lieuDeLivrasonTitleDesarchiver');
      }
      return this.isFactor ? this.$t('detailFournisseur.archivage.factorTitleDesarchiver')
        : this.$t('detailFournisseur.archivage.titleDesarchiver');
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      try {
        const response = await edition({
          ids: [this.fournisseur.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        const errorResponseString = await readErrorBlobRequest(e.response.data);
        const response = JSON.parse(errorResponseString);
        validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
          this.errorEdition.messages, this.errorEdition.messagesChampsVide);
        this.errorEdition.haveError = true;
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async archiver() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.openPopUpPrevention = false;
        const params = {
          ids: [this.fournisseur.id],
          archiver: !this.fournisseur.archive,
        };
        const fournisseurArchive = (await archiverEnMasse(params)).data.result.items[0];

        const sucessArchivage = this.isFactor ? this.$i18n.t('detailFournisseur.archivage.sucessArchivageFactor')
          : this.$i18n.t('detailFournisseur.archivage.sucessArchivage');
        const sucessDesarchivage = this.isFactor ? this.$i18n.t('detailFournisseur.archivage.sucessDesarchivageFactor')
          : this.$i18n.t('detailFournisseur.archivage.sucessDesarchivage');
        messageSucces(!this.fournisseur.archive ? sucessArchivage : sucessDesarchivage);
        this.fournisseur.archive = fournisseurArchive.archive;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'Client' });
      const fournisseur = (await get(this.$route.params.id)).data.result;
      fournisseur.contacts = (await getAllByTiers(fournisseur.id)).data.result.items;
      await this.setAttachmentElementId({ id: fournisseur.id });
      this.fournisseur = fournisseur;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.fournisseur.nomCommercial }));
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
